import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isMessageTemplateLoaded: false,
    messageTemplateList: [],
    isSaving: false,
}

const messageTemplatelistSlice = createSlice({
    name: 'messagetemplatelist',
    initialState,
    extraReducers: (builder) => {
        // GetAllMessageTemplate
        builder.addCase(actions.getMessageTemplate.pending, (state) => {
            state.isMessageTemplateLoaded = false;
        })
        builder.addCase(actions.getMessageTemplate.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.messageTemplateList = action.payload.data;
            } else {
                state.messageTemplateList = [];
            }
            state.isMessageTemplateLoaded = true;
        })
        builder.addCase(actions.getMessageTemplate.rejected, (state) => {
            state.isMessageTemplateLoaded = false;
        });


        // Add Edit Message Template

        builder.addCase(actions.addEditMessageTemplate.pending, (state) => {
            state.isSaving = true;
        })
        builder.addCase(actions.addEditMessageTemplate.fulfilled, (state, action) => {
            if (action.payload.success) {
                const returnObj = action.payload.data;
                const messageTemplateObj = state.messageTemplateList.find(x => x.baseId === returnObj.baseId);
                if (messageTemplateObj !== undefined && messageTemplateObj !== null) {
                    messageTemplateObj.name = returnObj.name;
                    messageTemplateObj.spanishContent = returnObj.spanishContent;
                    messageTemplateObj.englishContent = returnObj.englishContent;        
                    messageTemplateObj.id = returnObj.id;
                } else {
                    state.messageTemplateList.unshift(returnObj);
                }
            }
            state.isSaving = false;
        })
        builder.addCase(actions.addEditMessageTemplate.rejected, (state) => {
            state.isSaving = false;
        });

        // Delete Message Template
       
        builder.addCase(actions.deleteTemplate.pending, (state) => {
            state.saving = true;
        })
        builder.addCase(actions.deleteTemplate.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                const enityIndex = state.messageTemplateList.findIndex(x => x.id === id);
                if (enityIndex > -1) {
                    state.messageTemplateList.splice(enityIndex, 1);
                }
            }
            state.isSaving = false;
        })
        builder.addCase(actions.deleteTemplate.rejected, (state) => {
            state.isSaving = false;
        });


    }
});

export default messageTemplatelistSlice.reducer;